/* eslint-disable */
import React from 'react';
import styled from 'styled-components';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';
import { setScrollTop } from '../../../utils/scroll';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
`;

const Content = styled(FlexBox)`
  width: 100%;
  height: auto;
  align-content: center;
  margin: 0 auto;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMLight};
  position: relative;
  align-content: start;
`;
const Row = styled.div`
  align-content: start;
  > .table-cell {
    height: auto;
    overflow: hidden;
    width: 1260px;
    margin: 0 auto;
  }
  &.static {
    width: 100%;
    padding-top: 200px;
    background: url(${require('./imgs/ecosystem-banner.jpg')}) center center;
    background-size: cover;
    height: calc(100vh - 60px);
    min-height: 559px;
    @media screen and (max-height: 768px) {
      padding-top: 140px;
    }
  }
  &.absolute {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 60px;
    @media screen and (max-height: 768px) {
      bottom: 30px;
    }
  }
`;
const Title = styled.div`
  color: #fff;
  font-size: 80px;
  font-weight: 300;
  margin-bottom: 60px;
  font-family: ${({ theme }) => theme.fontIBMExtraLight};
  @media screen and (max-height: 768px) {
    margin-bottom: 40px;
  }
`;
const Description = styled.div`
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontIBMRegular};
`;

const Item = styled(FlexBox)`
  width: 1260px;
  margin: 0 auto;
  color: #fff;
  border-bottom: 1px solid rgba(216, 216, 216, 0.4);
  font-family: ${({ theme }) => theme.fontIBMRegular};
  > div {
    width: 270px;
    font-size: 16px;
    color: #fff;
    line-height: 20px;
    padding-bottom: 60px;
    margin-bottom: -1px;
    cursor: pointer;
    &.active {
      border-bottom: 1px solid #f0b90b;
    }
  }
`;

type Props = {
  i18n: Object,
};

type States = {
  id: number,
};

export default
@withI18n
class Banner extends React.Component<Props, States> {
  static defaultProps = {
    i18n: {},
  };

  state = {
    id: 1,
  };

  _scrollHash = (name: string, id: number) => {
    this.setState({ id });
    setScrollTop(document.documentElement, document.getElementById(name).offsetTop);
  };

  render() {
    const { i18n } = this.props;
    const { id } = this.state;
    return (
      <WrapperBox direction="column">
        <Content direction="row" align="center" justify="center">
          <Row align="center" justify="center" className="static">
            <div className="table-cell">
              <Title>{getLabel('exchange-ecosystembanner-binanceEcosystem', i18n)}</Title>
              <Description>
                {getLabel('exchange-ecosystembanner-expanding', i18n)}
              </Description>
            </div>
          </Row>
          <Row className="absolute">
            <div className="table-cell">
              <Item justify="space-between">
                <div
                  className={id === 1 && 'active'}
                  onClick={() => this._scrollHash('scroll_1', 1)}
                >
                  {getLabel('exchange-ecosystembanner-cryptoAssetExchange', i18n)}
                </div>
                <div
                  className={id === 2 && 'active'}
                  onClick={() => this._scrollHash('scroll_2', 2)}
                >
                  {getLabel('exchange-ecosystembanner-investmentFundraising', i18n)}
                </div>
                <div
                  className={id === 3 && 'active'}
                  onClick={() => this._scrollHash('scroll_3', 3)}
                >
                  {getLabel('exchange-ecosystembanner-digitalAssetResearch', i18n)}
                </div>
                <div
                  className={id === 4 && 'active'}
                  onClick={() => this._scrollHash('scroll_4', 4)}
                >
                  {getLabel('exchange-ecosystem-supportAdoption', i18n)}
                </div>
              </Item>
            </div>
          </Row>
        </Content>
      </WrapperBox>
    );
  }
}
